/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Lot_History_Reason_DiscardInputs */

const vi_product_lot_history_reason_discard = /** @type {(inputs: Product_Lot_History_Reason_DiscardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huỷ bỏ`)
};

/**

* @param {Product_Lot_History_Reason_DiscardInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_lot_history_reason_discard = /** @type {((inputs?: Product_Lot_History_Reason_DiscardInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Lot_History_Reason_DiscardInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_lot_history_reason_discard(inputs)
});